import { createSlice } from '@reduxjs/toolkit';

const languages = [
  { value: 1, lang: 'en', label: 'English' },
  { value: 2, lang: 'es', label: 'Español' },
  { value: 0, lang: 'ru', label: 'Russian' },
  { value: 7, lang: 'pl', label: 'Polski' },
  { value: 3, lang: 'uz', label: "o'zbek" },
  { value: 4, lang: 'pt', label: 'Português' },
  { value: 6, lang: 'az', label: 'Azərbaycan' },
  { value: 5, lang: 'ar', label: 'عربي' },
  { value: 6, lang: 'am', label: 'አማርኛ' }
];

const infoSlice = createSlice({
  name: 'info',
  initialState: {
    casinoLanguages: languages,
    hiddenMenuItems: []
  },
  reducers: {
    setCasinoLanguages: (state, action) => {
      state.casinoLanguages = action.payload;
    },
    setHiddenMenuItems(state, action) {
      state.hiddenMenuItems = action.payload;
    },
    setAddHiddenMenuItems(state, action) {
      state.hiddenMenuItems.push(action.payload);
    },
    setRemoveHiddenMenuItems(state, action) {
      state.hiddenMenuItems = state.hiddenMenuItems.filter((item) => item !== action.payload);
    }
  }
});

export default infoSlice.reducer;

export const {
  setCasinoLanguages,
  setHiddenMenuItems,
  setAddHiddenMenuItems,
  setRemoveHiddenMenuItems
} = infoSlice.actions;
